<template>
    <div class="numbers__card col">
        <div class="numbers__card-inner">
            <div class="numbers__card-title">{{ number }}</div>
            <div class="numbers__card-text" v-html="text"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'NumbersCard',
    props: {
        number: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        }
    },
    setup: (props, ctx) => {

        return {

        }
    },
}
</script>

<style lang="scss">
    .numbers__card {
        flex: 1000 0 0;
        &-inner {
            padding: 21px 32px;
            border: 1px solid var(--c-gray-700);
            border-radius: var(--br-1);
            width: 100%;
        }
        &-title {
            font-size: 40px;
            line-height: 44px;
            color: var(--c-gray-100);
            font-family: var(--font-secondary);
            font-weight: 600;
            white-space: nowrap;
        }
        &-text {
            margin-top: 10px;
            font-family: var(--font_primary);
            font-size: 14px;
            line-height: 20px;
            color: var(--c-secondary-200);
        }
    }
</style>